import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Card, CardDropdownMenuItem, DropdownMenuItemClick } from '@gelato-api-ui/ui-kit/src/lib/cards/types/cards';
import { CommonModule } from '@angular/common';
import { DropdownMenuModule } from '@gelato-api-ui/sdk/src/lib/shared/dropdown-menu/dropdown-menu.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownMenuItemId } from '@api-ui-app/src/app/mockup-studio/types/mockup-studio-scenes';

@Component({
  standalone: true,
  selector: 'gd-card',
  imports: [CommonModule, DropdownMenuModule, NgxSkeletonLoaderModule, TranslateModule],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  @Input() card: Card;
  @Input() overlayBtnText: string;
  @Input() dropdownMenuItems: CardDropdownMenuItem[];

  @Output() dropdownMenuItemClick = new EventEmitter<DropdownMenuItemClick>();
  @Output() cardClick = new EventEmitter<Card>();

  readonly dropdownMenuItemId = DropdownMenuItemId;

  get backgroundImg(): string {
    return `url(${this.card?.previewUrl})`;
  }

  onCardClick() {
    this.cardClick.emit(this.card);
  }

  onDropdownMenuItemClick(id: string) {
    this.dropdownMenuItemClick.emit({ id, card: this.card });
  }
}
